export { default } from "./SliderWithDisplay";
